module.exports = __webpack_public_path__ + "img/1541646466.1d6774ab.jpg";